import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  changeStaticQueryParams,
  selectItemById,
  selectItemsIds,
  selectRequestState,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

export default function createContainer(ChildContainer) {
  class TopUsersContainer extends Component {
    constructor(props) {
      super(props);
      this.updateList();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.match.params.group !== this.props.match.params.group) {
        this.updateList();
      }
    }

    updateList = () => {
      this.props.changeStaticQueryParams({
        time: this.props.match.params.group
      });
      this.props.sendRequest();
    };

    render() {
      return <ChildContainer {...this.props} />;
    }
  }

  TopUsersContainer.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        topList: PropTypes.string,
        group: PropTypes.string
      }).isRequired
    }).isRequired,

    // CONNECT DISPATCH
    changeStaticQueryParams: PropTypes.func.isRequired,
    sendRequest: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, props) => ({
    requestState: selectRequestState(state, props.reducerName),
    itemsIds: selectItemsIds(state, props.reducerName),
    selectItemById: id => selectItemById(state, props.reducerName, id)
  });

  const mapDispatchToProps = (dispatch, props) => ({
    changeStaticQueryParams: queryParams =>
      dispatch(changeStaticQueryParams(props.reducerName, queryParams)),
    sendRequest: () => dispatch(sendRequest(props.reducerName))
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(TopUsersContainer);
}



// WEBPACK FOOTER //
// ./src/components/TopUsers/_common/TopUsersContainer.js